import type { ILineItem } from "../Summary";

export default abstract class Base {
	public isAdded = false;
	protected active: HTMLElement;
	protected addToCartFormElement: HTMLInputElement;
	protected readonly hiddenClass = "rt-display-none";
	protected onChange: () => void;
	protected options: Array<HTMLElement>;

	/**
	 * @param id
	 * @param onChange
	 * @param optionSelector
	 * @param activeOptionClass
	 */
	protected constructor(
		public id: string,
		onChange: () => void,
		public optionSelector: string,
		protected activeOptionClass: string,
	) {
		this.onChange = () => {
			this.handleChange();
			onChange();
		};
		this.options = Array.from(document.querySelectorAll(this.optionSelector));
		this.addToCartFormElement = document.querySelector(
			`input[name="${this.id}"]`,
		) as HTMLInputElement;

		this.active = this.options[0];
		this.addListeners();
	}

	public errorMessage(): string {
		return "";
	}

	public abstract getLineItems(): Array<ILineItem>;

	public isValid(): boolean {
		return true;
	}

	protected addListeners() {
		this.options.forEach((option) => {
			option.addEventListener("change", (e) => {
				this.setActiveOption(e, option);
			});
		});
	}

	protected createDetailsForPHP(): {
		[key: string]: boolean | number | string;
	} {
		return {
			added: this.isAdded,
			id: this.id,
			selected: this.active.dataset.label || "",
		};
	}

	protected getActiveLabel(): string {
		return this.active.dataset.label || "";
	}

	/**
	 * Gets the cost of the active option.
	 *
	 * @returns The cost of the active option.
	 */
	protected getActiveOptionCost(): number {
		const { value } = this.active.dataset;
		if (!value) {
			return 0;
		}
		return Number.parseFloat(value);
	}

	/**
	 * @param _e
	 * @param newActiveOption
	 */
	protected setActiveOption(_e: Event, newActiveOption: HTMLElement) {
		this.active = newActiveOption;
		this.isAdded = !newActiveOption.dataset.isnoneoption;
		this.onChange();
	}

	private handleChange() {
		this.addToCartFormElement.value = JSON.stringify(
			this.createDetailsForPHP(),
		);
	}
}
